<template>
  <div>
    <a-calendar>
      <ul class="events" slot="dateCellRender" slot-scope="value" v-if="!loading">
        <li :key="item.id" @click="openTaskModal(item)" v-for="item in getListData(value)">
          <a-tag style="cursor: pointer;" :title="item.taskCode" :color="filterStatus(item.taskStatus)">{{
            item.devName
          }}</a-tag>
        </li>
      </ul>
      <template slot="monthCellRender" slot-scope="value">
        <div class="notes-month" v-if="getMonthData(value)">
          <section>{{ getMonthData(value) }}</section>
        </div>
      </template>
    </a-calendar>
    <task-device-modal @ok="modalFormOk" ref="taskDevice"></task-device-modal>
  </div>
</template>
<script>
import { getAction } from '@/api/manage'
import { groupBy } from 'lodash'
import TaskDeviceModal from './modules/TaskDeviceModal'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'

export default {
  name: 'MaintaincePlanCalendar',
  data() {
    return {
      url: '/maintenance/devMaintainceTask/list',
      planList: new Map(),
      loading: true,
      groupByPlanDate: {},
      groupByPlanMonth: {}
    }
  },
  components: {
    TaskDeviceModal
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.queryData()
  },
  methods: {
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.queryData()
    },
    openTaskModal(record) {
      this.$refs.taskDevice.edit(record)
      this.$refs.taskDevice.title = record.taskStatus !== 2 ? '保养记录回填清单' : '保养清单'
      this.$refs.taskDevice.disableSubmit = record.taskStatus == 2
    },
    getListData(value) {
      const date = value.format('YYYY-MM-DD')
      const mapItem = this.groupByPlanDate[date]
      return mapItem || []
    },

    getMonthData(value) {
      const month = value.format('YYYY-MM')
      const mapItem = this.groupByPlanMonth[month]
      return mapItem?.length || 0
    },
    queryData() {
      getAction(this.url, {
        pageSize: 300,
        pageNo: 1
      }).then(res => {
        this.loading = false

        this.groupByPlanDate = groupBy(res.result.records, v => v.planTime)
        this.groupByPlanMonth = groupBy(res.result.records, v => v.planTime.substring(0, 7))
      })
    },
    filterStatus(text) {
      return this.$filterDictTextByCache('maintaince_task_color', text)
    }
  }
}
</script>
<style lang="less" scoped>
.events {
  list-style: none;
  margin: 0;
  padding: 0;
}
.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}
.notes-month {
  text-align: center;
  font-size: 28px;
}
.notes-month section {
  font-size: 28px;
}
::v-deep {
  .ant-fullcalendar-column-header {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .ant-fullcalendar-date {
    height: 72px;
    border-top: none;
    margin: 0px;
    .ant-fullcalendar-content {
      height: 44px;
      ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
    }
    .ant-fullcalendar-value {
      text-align: left;
      font-size: 16px;
      font-weight: 700;
    }
  }
  .ant-fullcalendar table,
  .ant-fullcalendar th,
  .ant-fullcalendar td {
    border: 1px solid #ebeff5;
  }
}
</style>
